import { useState } from "react";

export function useFormErrors() {
    const [error, setError] = useState<string | null>(null);
    const [emailError, setEmailError] = useState<string | null>(null);
    const [cnpjError, setCnpjError] = useState<string | null>(null);

    return { error, emailError, cnpjError, setError, setEmailError, setCnpjError };
}